module.exports = __webpack_public_path__ + "media/images/google-color-ea7174418615bb2b0b56a1ec41aa511d.svg";